export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-multiple-fe79003e31715cc5a5a154dccfb79060.svg";